import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import {loadingCompanies, selectCompanies} from "../../redux/reducers/companies-reducer";
import {loadingContracts, selectContracts} from "../../redux/reducers/contract-reducer";
import {loadingUsers, selectUsers} from "../../redux/reducers/users-reducer";

import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import {UsersTable} from "../../components/UsersTable/UsersTable";
import {UserDialog} from "../../components/UserDialog/UserDialog";
import {AddButton} from "../../components/AddButton/AddButton";
import {useDialog} from "../../hooks/useDialog";
import {UserDialogModes} from "../../utils/users";


export const UsersPage = () => {
    const {users, loading: userLoading} = useSelector(selectUsers)
    const {companies, loading: companiesLoading} = useSelector(selectCompanies)
    const {contracts, loading: contractsLoading} = useSelector(selectContracts)

    const dispatch = useDispatch()

    const {open, handleClose, handleOpen} = useDialog()
    const [userDialogMode, setUserDialogMode] = useState(UserDialogModes.CREATE)
    const [selectedUser, setSelectedUser] = useState(undefined)

    useEffect(() => {
        dispatch(loadingCompanies)
        dispatch(loadingContracts)
        dispatch(loadingUsers)
    }, [dispatch])

    const onAddButtonClick = () => {
        setSelectedUser(undefined)
        setUserDialogMode(UserDialogModes.CREATE)
        handleOpen()
    }

    const onTableRowClick = ({row}) => {
        setSelectedUser(row)
        setUserDialogMode(UserDialogModes.CHANGE)
        handleOpen()
    }

    return <CommonLayout>
        <Grid container direction={'column'}>
            <Grid item container alignItems={'center'}>
                <Grid item>
                    <Typography variant={'h5'}>Пользователи</Typography>
                </Grid>
                <Grid item>
                    <AddButton onClick={onAddButtonClick}/>
                </Grid>
            </Grid>
            <Grid item style={{height: '80vh'}}>
                <UsersTable users={users}
                            companies={companies}
                            contracts={contracts}
                            onRowClick={onTableRowClick}
                            loading={companiesLoading && userLoading && contractsLoading}
                />
            </Grid>
        </Grid>
        {open ? <UserDialog open={open}
                     handleClose={handleClose}
                     mode={userDialogMode}
                     user={selectedUser}
                     companies={companies}
                     contracts={contracts}
        />: undefined}
    </CommonLayout>
}